export default function () {
  return [
    {
      key: 'accounts',
      label: 'accounts',
      type: 'accountPicker',
      props: {
        multiple: true,
        size: "sm",
        sm: true
      },
    },
    {
        key: 'groupTransactionId',
        label: 'groupTransactionId',
        type: 'input',
    }
  ]
}
